import { SessionState } from "../../redux/types/SessionState";
import { createChannel } from "./createChannel";

// Create a type-safe iframe channel that can transfer jupyter specific messages.
const [sessionStatePublisher, sessionStateSubscriber] = createChannel<
  SessionState
>({
  name: "session-state-channel",
  // TODO(cochamberlain): Implement origins with definePlugin.
  publisherOrigin: "*",
  subscriberOrigin: "*",
});

export { sessionStatePublisher, sessionStateSubscriber };
